<template>
  <div
    class="dragFile"
    :class="{dragEnter, uploading}"
    @click="$refs.fileInput.click()"
    @drop.prevent="addFile"
    @dragover.prevent
    @dragenter.stop="dragEnter = true"
    @dragleave.stop="dragEnter = false"
  >
    <input type="file" v-bind="$attrs" :id="idInput" @change="uploadImages" ref="fileInput" multiple style="display: none">
    <bim-text-desc bold class="upload-text" v-if="uploading">Файлы загружаются... Подождите</bim-text-desc>
    <slot v-else/>
  </div>
</template>

<script>
import bimTextDesc from '@bimlib/components/bimTextDesc'

export default {
  name: 'uploadFiles',
  components: { bimTextDesc },
  props: {
    value: {
      type: Array,
      default: [],
    },
    idInput: String,
    uploading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      files: [],
      dragEnter: false,
    }
  },
  watch: {
    files (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.files = val
    },
  },
  methods: {
    uploadImages (event) {
      const files = event.target.files
      // this.files.push(...files)
      this.$emit('change', files)
    },
    addFile (e) {
      // console.log(e)
      this.dragEnter = false
      let droppedFiles = e.dataTransfer.files
      if (!droppedFiles) return
      // [...droppedFiles].forEach(f => this.files.push(f))
      this.$emit('change', droppedFiles)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.dragFile {
  display          : flex;
  align-items      : center;
  justify-content  : center;
  width            : 100%;
  height           : 200px;
  background-color : #fafafa;
  border-radius    : 5px;
  cursor           : pointer;
  transition       : all .2s;

  &:hover {
    background-color : #eeeeee;
  }

  &.uploading {
    @extend .dragEnter;
    animation : border-dance 1s infinite linear;
  }
}

.upload-text {
  color : #777777;
}

.dragEnter {
  transition          : background-image .2s;

  background-image    : linear-gradient(90deg, $primary-color 50%, transparent 50%), linear-gradient(90deg, $primary-color 50%, transparent 50%), linear-gradient(0deg, $primary-color 50%, transparent 50%), linear-gradient(0deg, $primary-color 50%, transparent 50%);
  background-repeat   : repeat-x, repeat-x, repeat-y, repeat-y;
  background-size     : 15px 2px, 15px 2px, 2px 15px, 2px 15px;
  background-position : left top, right bottom, left bottom, right top;
}

@keyframes border-dance {
  0% {
    background-position : left top, right bottom, left bottom, right top;
  }
  100% {
    background-position : left 15px top, right 15px bottom, left bottom 15px, right top 15px;
  }
}
</style>
